import { call, takeEvery, takeLatest } from "redux-saga/effects";
import { GET_FULL_PROFILE, UPDATE_FULL_PROFILE, GET_PROGRESS_SUMMARY, GET_PROGRESS_HISTORY, UPDATE_PROGRESS_ENTRY, DELETE_PROGRESS_ENTRY, UPDATE_MEDICAL_HISTORY, GET_MEDICAL_HISTORY, GET_REPORTS, DELETE_REPORT, GET_FOOD_LIFESTYLE, UPDATE_FOOD_LIFESTYLE, GET_RECALL, UPDATE_RECALL, GET_ACTIVITY_BY_DATE, SET_ACTIVITY_GOAL, GET_FIRST_LAST_MEASURE, GET_ALL_MEASURES, DELETE_MEASURE_BY_ID, GET_BODY_STARTED_CURRENT, GET_ALL_BODY_MEASURES, DELETE_BODY_MEASURE_BY_ID, GET_ALL_LEADS, GET_ALL_CUSTOMERS, GET_CLUSTERS, GET_PRACTITIONERS, GET_CLINICS, GET_TAGS, GET_COUNTRIES, GET_STATES, GET_CITIES, GET_CUISINES, GET_DIET, UPLOAD_PROGRAM_IMAGE, UPLOAD_IMAGE, CREATE_PROGRAM, GET_PROGRAM_RECORDED_VIDEOS, SAVE_PROGRAM_RECORDED_VIDEOS, DELETE_PROGRAM_RECORDED_VIDEO, GET_CLINICS_FOR_PROGRAM, UPLOAD_SESSION_IMAGE, CREATE_SESSION, GET_ALL_SESSIONS, GET_SESSION_BY_ID, UPDATE_SESSION, CREATE_MEALS_CONFIGURATION, UPLOAD_MEALS_IMAGE, GET_MEALS_USER, GET_MEALS_USER_BY_ID, UPDATE_MEAL_CONFIGURATION_BY_ID, UPLOAD_MENU_ITEM_IMAGE, CREATE_MENU_ITEM, CHECK_ABHA_EXISTS, VERIFY_ABHA_PHONE, VERIFY_ABHA_OTP, ADD_ABHA, GET_ALL_ABHA_CUSTOMERS, LINK_ABHA_DOCUMENT, GET_ITEM_CATEGORIES, EDIT_CATEGORY, CREATE_CATEGORY, GET_ITEM_PRODUCTS, GET_PRODUCT_BY_ID, CREATE_CUSTOMER, CONVERT_TO_LEAD, GET_CAROUSEL_URLS, UPLOAD_CAROUSEL_IMAGE, DELETE_CAROUSEL_IMAGE, GET_SOCIAL_LINKS, GET_ABOUT_US, SET_ABOUT_US, DELETE_CUSTOMER_ACCOUNT, DELETE_USER_ACCOUNT, UPLOAD_ABOUT_US_IMAGE, SET_SOCIAL_LINKS, GET_DIET_COMPLIANCE, GET_DIET_PLAN_CONFIG, SET_DIET_PLAN_START_DATE, SET_DIET_COMPLIANCE, GET_BOOKED_SESSIONS_BY_DATE, CHANGE_SESSION_STATUS, GET_MEAL_OPTIONS, GET_MEAL_MANAGEMENT_ORDERS, GET_GUIDELINES, SET_OR_UPDATE_GUIDELINES, GET_BOOKED_SESSIONS_BY_CUSTOMER, GET_MENU_ITEM_BY_ID, UPDATE_MENU_ITEM_BY_ID, CREATE_HEALTH_FEED, GET_ALL_HEALTH_FEED, GET_HEALTH_FEED_BY_ID, DELETE_HEALTH_FEED, UPDATE_HEALTH_FEED, GET_LIST_OF_ENROLLMENTS, GET_ENROLLMENT_RESPONSE, GET_PROMOS, GET_ALL_DIET_COMPLIANCE, GET_CUSTOMER_PAYMENTS, GET_DOCUMENTS, SET_DOCUMENT, UPDATE_DOCUMENT, DELETE_DOCUMENT, GET_CUSTOMER_HISTORY, GET_CUSTOMER_FOOD_LOGS, GET_PROGRAM_ENROLLED_USERS, GET_SESSION_BOOKED_USERS } from "../types";
import { GetCustFullProfileApi, UpdateCustFullProfileApi, GetProgressSummaryApi, GetProgressHistoryApi, UpdateProgressEntryApi, DeleteProgressEntryApi, UpdateMedicalHistoryApi, GetMedicalHistoryApi, GetReportsApi, DeleteReportApi, GetFoodLifestyleApi, UpdateFoodLifestyleApi, GetRecallApi, UpdateRecallApi, GetActivityByDateApi, SetActivityGoalApi, GetFirstLastMeasureApi, GetAllMeasuresApi, DeleteMeasureByIdApi, GetBodyStartedCurrentApi, GetAllBodyMeasuresApi, DeleteBodyMeasureByIdApi, GetAllLeadsApi, GetAllCustomersApi, GetClustersApi, GetPractitionersApi, GetClinicsApi, GetTagsApi, GetCountriesApi, GetStatesApi, GetCitiesApi, GetCuisinesApi, GetDietApi, UploadProgramImageApi, CreateProgramApi, GetProgramRecordedVideosApi, SaveProgramRecordedVideosApi, DeleteProgramRecordedVideoApi, GetClinicsForProgramApi, UploadSessionImageApi, CreateSessionApi, GetAllSessionsApi, GetSessionByIdApi, UpdateSessionApi, CreateMealsConfigurationApi, UploadMealsImageApi, GetMealsUserApi, GetMealsUserByIdApi, UpdateMealConfigurationByIdApi, UploadMenuItemImageApi, CreateMenuItemApi, CheckAbhaExistsApi, VerifyAbhaPhoneApi, VerifyAbhaOtpApi, AddAbhaApi, GetAllAbhaCustomersApi, LinkAbhaDocumentApi, GetItemCategoriesApi, EditCategoryApi, CreateCategoryApi, GetItemProductsApi, GetProductByIdApi, CreateCustomerApi, ConvertToLeadApi, GetCarouselUrlsApi, UploadCarouselImageApi, DeleteCarouselImageApi, GetSocialLinksApi, GetAboutUsApi, SetAboutUsApi, DeleteCustomerAccountApi, DeleteUserAccountApi, UploadAboutUsImageApi, SetSocialLinksApi, GetDietComplianceApi, GetDietPlanConfigApi, SetDietPlanStartDateApi, SetDietComplianceApi, GetBookedSessionsByDateApi, ChangeSessionStatusApi, GetMealOptionsApi, GetMealManagementOrdersApi, GetGuidelinesApi, SetOrUpdateGuidelinesApi, GetBookedSessionsByCustomerApi, UploadImageApi, GetMenuItemByIdApi, UpdateMenuItemByIdApi, CreateHealthFeedApi, GetAllHealthFeedApi, GetHealthFeedByIdApi, DeleteHealthFeedApi, UpdateHealthFeedApi, GetListOfEnrollmentsApi, GetEnrollmentResponseApi, GetPromosApi, GetCustomerPaymentsApi, GetAllDietComplianceApi, GetDocumentsApi, SetDocumentApi, UpdateDocumentApi, DeleteDocumentApi, GetCustomerHistoryApi, GetCustomerFoodLogsApi, GetProgramEnrolledUsersApi, GetSessionBookedUsersApi } from "../api/profile-customer";

export function* getCustFullProfileWorker(action: any): any {
  try {
    const res: any = yield call(GetCustFullProfileApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateCustFullProfileWorker(action: any): any {
  try {
    const res: any = yield call(UpdateCustFullProfileApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getMedicalHistoryWorker(action: any): any {
  try {
    const res: any = yield call(GetMedicalHistoryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateMedicalHistoryWorker(action: any): any {
  try {
    const res: any = yield call(UpdateMedicalHistoryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getProgressSummaryWorker(action: any): any {
  try {
    const res: any = yield call(GetProgressSummaryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getProgressHistoryWorker(action: any): any {
  try {
    const res: any = yield call(GetProgressHistoryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCustFullProfileWatcher() {
  /*
   * takeEvery, NOT takeLatest.
   *
   * Two components legitimately want this record at the same time: the Contact
   * Profile header and the Basic Details form inside it. Under takeLatest the
   * parent's dispatch cancelled the child's — React runs child effects first,
   * so the form's request was always the one killed. The header filled in and
   * every field below it stayed blank, which looked like a slow or failed load.
   *
   * Switching tabs and coming back "fixed" it because only the child remounts
   * then, leaving nothing to cancel it.
   *
   * Each caller passes its own onSuccess and writes its own state, so there is
   * no shared slice for a late response to overwrite — which is the thing
   * takeLatest exists to prevent.
   */
  yield takeEvery(GET_FULL_PROFILE, getCustFullProfileWorker);
}

export function* updateCustFullProfileWatcher() {
  yield takeLatest(UPDATE_FULL_PROFILE, updateCustFullProfileWorker);
}

export function* getMedicalHistoryWatcher() {
  yield takeLatest(GET_MEDICAL_HISTORY, getMedicalHistoryWorker);
}

export function* updateMedicalHistoryWatcher() {
  yield takeLatest(UPDATE_MEDICAL_HISTORY, updateMedicalHistoryWorker);
}

export function* getProgressSummaryWatcher() {
  yield takeLatest(GET_PROGRESS_SUMMARY, getProgressSummaryWorker);
}

export function* getProgressHistoryWatcher() {
  yield takeLatest(GET_PROGRESS_HISTORY, getProgressHistoryWorker);
}

export function* updateProgressEntryWorker(action: any): any {
  try {
    const res: any = yield call(UpdateProgressEntryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteProgressEntryWorker(action: any): any {
  try {
    const res: any = yield call(DeleteProgressEntryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getReportsWorker(action: any): any {
  try {
    const res: any = yield call(GetReportsApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateProgressEntryWatcher() {
  yield takeLatest(UPDATE_PROGRESS_ENTRY, updateProgressEntryWorker);
}

export function* deleteProgressEntryWatcher() {
  yield takeLatest(DELETE_PROGRESS_ENTRY, deleteProgressEntryWorker);
}

export function* getReportsWatcher() {
  yield takeLatest(GET_REPORTS, getReportsWorker);
}

export function* deleteReportWorker(action: any): any {
  try {
    const res: any = yield call(DeleteReportApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteReportWatcher() {
  yield takeLatest(DELETE_REPORT, deleteReportWorker);
}

export function* getFoodLifestyleWorker(action: any): any {
  try {
    const res: any = yield call(GetFoodLifestyleApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateFoodLifestyleWorker(action: any): any {
  try {
    const res: any = yield call(UpdateFoodLifestyleApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getFoodLifestyleWatcher() {
  yield takeLatest(GET_FOOD_LIFESTYLE, getFoodLifestyleWorker);
}

export function* updateFoodLifestyleWatcher() {
  yield takeLatest(UPDATE_FOOD_LIFESTYLE, updateFoodLifestyleWorker);
}

export function* getRecallWorker(action: any): any {
  try {
    const res: any = yield call(GetRecallApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getRecallWatcher() {
  yield takeLatest(GET_RECALL, getRecallWorker);
}

export function* updateRecallWorker(action: any): any {
  try {
    const res: any = yield call(UpdateRecallApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateRecallWatcher() {
  yield takeLatest(UPDATE_RECALL, updateRecallWorker);
}

export function* getActivityByDateWorker(action: any): any {
  try {
    const res: any = yield call(GetActivityByDateApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getActivityByDateWatcher() {
  yield takeLatest(GET_ACTIVITY_BY_DATE, getActivityByDateWorker);
}

export function* setActivityGoalWorker(action: any): any {
  try {
    const res: any = yield call(SetActivityGoalApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* setActivityGoalWatcher() {
  yield takeLatest(SET_ACTIVITY_GOAL, setActivityGoalWorker);
}

export function* getFirstLastMeasureWorker(action: any): any {
  try {
    const res: any = yield call(GetFirstLastMeasureApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getFirstLastMeasureWatcher() {
  yield takeLatest(GET_FIRST_LAST_MEASURE, getFirstLastMeasureWorker);
}

export function* getAllMeasuresWorker(action: any): any {
  try {
    const res: any = yield call(GetAllMeasuresApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllMeasuresWatcher() {
  yield takeLatest(GET_ALL_MEASURES, getAllMeasuresWorker);
}

export function* deleteMeasureByIdWorker(action: any): any {
  try {
    const res: any = yield call(DeleteMeasureByIdApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteMeasureByIdWatcher() {
  yield takeLatest(DELETE_MEASURE_BY_ID, deleteMeasureByIdWorker);
}

export function* getBodyStartedCurrentWorker(action: any): any {
  try {
    const res: any = yield call(GetBodyStartedCurrentApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getBodyStartedCurrentWatcher() {
  yield takeLatest(GET_BODY_STARTED_CURRENT, getBodyStartedCurrentWorker);
}

export function* getAllBodyMeasuresWorker(action: any): any {
  try {
    const res: any = yield call(GetAllBodyMeasuresApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllBodyMeasuresWatcher() {
  yield takeLatest(GET_ALL_BODY_MEASURES, getAllBodyMeasuresWorker);
}

export function* deleteBodyMeasureByIdWorker(action: any): any {
  try {
    const res: any = yield call(DeleteBodyMeasureByIdApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteBodyMeasureByIdWatcher() {
  yield takeLatest(DELETE_BODY_MEASURE_BY_ID, deleteBodyMeasureByIdWorker);
}

export function* getAllLeadsWorker(action: any): any {
  try {
    const res: any = yield call(GetAllLeadsApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllLeadsWatcher() {
  yield takeLatest(GET_ALL_LEADS, getAllLeadsWorker);
}

export function* getAllCustomersWorker(action: any): any {
  try {
    const res: any = yield call(GetAllCustomersApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllCustomersWatcher() {
  yield takeLatest(GET_ALL_CUSTOMERS, getAllCustomersWorker);
}

export function* getClustersWorker(action: any): any {
  try {
    const res: any = yield call(GetClustersApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getClustersWatcher() {
  yield takeLatest(GET_CLUSTERS, getClustersWorker);
}

export function* getPractitionersWorker(action: any): any {
  try {
    const res: any = yield call(GetPractitionersApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getPractitionersWatcher() {
  yield takeLatest(GET_PRACTITIONERS, getPractitionersWorker);
}

export function* getClinicsWorker(action: any): any {
  try {
    const res: any = yield call(GetClinicsApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getClinicsWatcher() {
  yield takeLatest(GET_CLINICS, getClinicsWorker);
}

export function* getTagsWorker(action: any): any {
  try {
    const res: any = yield call(GetTagsApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getTagsWatcher() {
  yield takeLatest(GET_TAGS, getTagsWorker);
}

export function* getCountriesWorker(action: any): any {
  try {
    const res: any = yield call(GetCountriesApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCountriesWatcher() {
  yield takeLatest(GET_COUNTRIES, getCountriesWorker);
}

export function* getStatesWorker(action: any): any {
  try {
    const res: any = yield call(GetStatesApi, action.data.countryId);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getStatesWatcher() {
  yield takeLatest(GET_STATES, getStatesWorker);
}

export function* getCitiesWorker(action: any): any {
  try {
    const res: any = yield call(GetCitiesApi, action.data.stateId);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCitiesWatcher() {
  yield takeLatest(GET_CITIES, getCitiesWorker);
}

export function* getCuisinesWorker(action: any): any {
  try {
    const res: any = yield call(GetCuisinesApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCuisinesWatcher() {
  yield takeLatest(GET_CUISINES, getCuisinesWorker);
}

export function* getDietWorker(action: any): any {
  try {
    const res: any = yield call(GetDietApi);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getDietWatcher() {
  yield takeLatest(GET_DIET, getDietWorker);
}

// Program related sagas
export function* uploadProgramImageWorker(action: any): any {
  try {
    const response: any = yield call(UploadProgramImageApi, action.file);
    // Gated like the other 83 workers: this API reports failures as HTTP 200
    // with `status: false`, so axios does not throw and the catch below never
    // runs. Ungated, a rejected call reached onSuccess and the screen reported
    // success for work the server refused.
    //
    // onSuccess still receives the whole axios response, not response.data —
    // the upload callers read `response?.data?.data?.url` off it.
    if ((response?.status === 200 || response?.status === 201) && response?.data?.status !== false) {
      yield call(action.onSuccess, response);
    } else {
      yield call(action.onError, response?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadProgramImageWatcher() {
  yield takeLatest(UPLOAD_PROGRAM_IMAGE, uploadProgramImageWorker);
}

export function* createProgramWorker(action: any): any {
  try {
    const response: any = yield call(CreateProgramApi, action.data);
    // Gated like the other 83 workers: this API reports failures as HTTP 200
    // with `status: false`, so axios does not throw and the catch below never
    // runs. Ungated, a rejected call reached onSuccess and the screen reported
    // success for work the server refused.
    //
    // onSuccess still receives the whole axios response, not response.data —
    // the upload callers read `response?.data?.data?.url` off it.
    if ((response?.status === 200 || response?.status === 201) && response?.data?.status !== false) {
      yield call(action.onSuccess, response);
    } else {
      yield call(action.onError, response?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createProgramWatcher() {
  yield takeLatest(CREATE_PROGRAM, createProgramWorker);
}

/**
 * Who registered for a program, and who booked an appointment.
 *
 * Gated like the other workers: these APIs report a missing route as HTTP 200
 * with `status: false`, so axios does not throw and the catch never runs.
 *
 * The gate matters more than usual here. A missing id and a malformed date both
 * come back as HTTP 200 with `status: false` and a real message ("prog_id is
 * required", or the driver's own "invalid input syntax for type date"), so
 * ungated they would reach onSuccess and the dialog would show an empty list as
 * though nobody had registered. An id that genuinely has no registrations is
 * `status: true` with an empty array, which is the case that must still succeed.
 */
export function* getProgramEnrolledUsersWorker(action: any): any {
  try {
    const res: any = yield call(GetProgramEnrolledUsersApi, action.params);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getProgramEnrolledUsersWatcher() {
  yield takeLatest(GET_PROGRAM_ENROLLED_USERS, getProgramEnrolledUsersWorker);
}

export function* getSessionBookedUsersWorker(action: any): any {
  try {
    const res: any = yield call(GetSessionBookedUsersApi, action.params);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getSessionBookedUsersWatcher() {
  yield takeLatest(GET_SESSION_BOOKED_USERS, getSessionBookedUsersWorker);
}

/**
 * One customer's food-log photos.
 *
 * Gated like the other workers: this API reports a missing route as HTTP 200
 * with `status: false`, so axios does not throw and the catch below never runs.
 *
 * A customer with no photos is NOT a failure — it returns `status: true` with
 * `total: 0`, confirmed against a customer who has none — so it reaches
 * onSuccess and the tab shows its empty state rather than an error.
 */
export function* getCustomerFoodLogsWorker(action: any): any {
  try {
    const res: any = yield call(GetCustomerFoodLogsApi, action.params);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCustomerFoodLogsWatcher() {
  yield takeLatest(GET_CUSTOMER_FOOD_LOGS, getCustomerFoodLogsWorker);
}

/**
 * Every app customer, for the User History screen.
 *
 * Gated like the other workers: this API answers a missing route with HTTP 200
 * and `status: false`, so axios never throws and the catch below never runs.
 * Ungated, a "Page not found" would reach onSuccess and the screen would render
 * an empty list as if there genuinely were no customers.
 *
 * An empty page is NOT a failure here — asking past the last page returns
 * `status: true` with an empty array, so it reaches onSuccess and the caller
 * stops paging rather than showing an error.
 */
export function* getCustomerHistoryWorker(action: any): any {
  try {
    const res: any = yield call(GetCustomerHistoryApi, action.params);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCustomerHistoryWatcher() {
  yield takeLatest(GET_CUSTOMER_HISTORY, getCustomerHistoryWorker);
}

export function* getProgramRecordedVideosWorker(action: any): any {
  try {
    const res: any = yield call(GetProgramRecordedVideosApi, action.progId);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getProgramRecordedVideosWatcher() {
  yield takeLatest(GET_PROGRAM_RECORDED_VIDEOS, getProgramRecordedVideosWorker);
}

export function* saveProgramRecordedVideosWorker(action: any): any {
  try {
    const res: any = yield call(SaveProgramRecordedVideosApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* saveProgramRecordedVideosWatcher() {
  yield takeLatest(SAVE_PROGRAM_RECORDED_VIDEOS, saveProgramRecordedVideosWorker);
}

export function* deleteProgramRecordedVideoWorker(action: any): any {
  try {
    const res: any = yield call(DeleteProgramRecordedVideoApi, action.recordedId);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteProgramRecordedVideoWatcher() {
  yield takeLatest(DELETE_PROGRAM_RECORDED_VIDEO, deleteProgramRecordedVideoWorker);
}

export function* getClinicsForProgramWorker(action: any): any {
  try {
    const response: any = yield call(GetClinicsForProgramApi);
    // Gated like the other 83 workers: this API reports failures as HTTP 200
    // with `status: false`, so axios does not throw and the catch below never
    // runs. Ungated, a rejected call reached onSuccess and the screen reported
    // success for work the server refused.
    //
    // onSuccess still receives the whole axios response, not response.data —
    // the upload callers read `response?.data?.data?.url` off it.
    if ((response?.status === 200 || response?.status === 201) && response?.data?.status !== false) {
      yield call(action.onSuccess, response);
    } else {
      yield call(action.onError, response?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getClinicsForProgramWatcher() {
  yield takeLatest(GET_CLINICS_FOR_PROGRAM, getClinicsForProgramWorker);
}

// Session related sagas
export function* uploadSessionImageWorker(action: any): any {
  try {
    const response: any = yield call(UploadSessionImageApi, action.file);
    // Gated like the other 83 workers: this API reports failures as HTTP 200
    // with `status: false`, so axios does not throw and the catch below never
    // runs. Ungated, a rejected call reached onSuccess and the screen reported
    // success for work the server refused.
    //
    // onSuccess still receives the whole axios response, not response.data —
    // the upload callers read `response?.data?.data?.url` off it.
    if ((response?.status === 200 || response?.status === 201) && response?.data?.status !== false) {
      yield call(action.onSuccess, response);
    } else {
      yield call(action.onError, response?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadSessionImageWatcher() {
  yield takeLatest(UPLOAD_SESSION_IMAGE, uploadSessionImageWorker);
}

export function* createSessionWorker(action: any): any {
  try {
    const res: any = yield call(CreateSessionApi, action.data);
    // This API reports failures as HTTP 200 with `status: false`, so axios does
    // not throw and the catch below never runs. Without this check a rejected
    // create was handed to onSuccess: the form said "Created appointment
    // successfully" and navigated away while nothing had been saved, and the
    // server's reason was thrown away. updateSessionWorker already checked.
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createSessionWatcher() {
  yield takeLatest(CREATE_SESSION, createSessionWorker);
}

export function* getAllSessionsWorker(action: any): any {
  try {
    const type = action.data?.type || "published";
    const res: any = yield call(GetAllSessionsApi, type);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllSessionsWatcher() {
  yield takeLatest(GET_ALL_SESSIONS, getAllSessionsWorker);
}

export function* getSessionByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetSessionByIdApi, action.data.sessionId);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getSessionByIdWatcher() {
  yield takeLatest(GET_SESSION_BY_ID, getSessionByIdWorker);
}

export function* updateSessionWorker(action: any): any {
  try {
    const res: any = yield call(UpdateSessionApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateSessionWatcher() {
  yield takeLatest(UPDATE_SESSION, updateSessionWorker);
}

export function* createMealsConfigurationWorker(action: any): any {
  try {
    const res: any = yield call(CreateMealsConfigurationApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createMealsConfigurationWatcher() {
  yield takeLatest(CREATE_MEALS_CONFIGURATION, createMealsConfigurationWorker);
}

export function* uploadMealsImageWorker(action: any): any {
  try {
    const res: any = yield call(UploadMealsImageApi, action.data.file);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadMealsImageWatcher() {
  yield takeLatest(UPLOAD_MEALS_IMAGE, uploadMealsImageWorker);
}

export function* getMealsUserWorker(action: any): any {
  try {
    const res: any = yield call(GetMealsUserApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getMealsUserWatcher() {
  yield takeLatest(GET_MEALS_USER, getMealsUserWorker);
}

export function* getMealsUserByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetMealsUserByIdApi, action.data.mealConfigId);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getMealsUserByIdWatcher() {
  yield takeLatest(GET_MEALS_USER_BY_ID, getMealsUserByIdWorker);
}

export function* updateMealConfigurationByIdWorker(action: any): any {
  try {
    const res: any = yield call(UpdateMealConfigurationByIdApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateMealConfigurationByIdWatcher() {
  yield takeLatest(UPDATE_MEAL_CONFIGURATION_BY_ID, updateMealConfigurationByIdWorker);
}

// Menu Item related sagas
export function* uploadMenuItemImageWorker(action: any): any {
  try {
    const res: any = yield call(UploadMenuItemImageApi, action.data.file);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadMenuItemImageWatcher() {
  yield takeLatest(UPLOAD_MENU_ITEM_IMAGE, uploadMenuItemImageWorker);
}

export function* createMenuItemWorker(action: any): any {
  try {
    const res: any = yield call(CreateMenuItemApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createMenuItemWatcher() {
  yield takeLatest(CREATE_MENU_ITEM, createMenuItemWorker);
}

export function* getMenuItemByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetMenuItemByIdApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getMenuItemByIdWatcher() {
  yield takeLatest(GET_MENU_ITEM_BY_ID, getMenuItemByIdWorker);
}

export function* updateMenuItemByIdWorker(action: any): any {
  try {
    const res: any = yield call(UpdateMenuItemByIdApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateMenuItemByIdWatcher() {
  yield takeLatest(UPDATE_MENU_ITEM_BY_ID, updateMenuItemByIdWorker);
}

// ABHA related sagas
export function* checkAbhaExistsWorker(action: any): any {
  try {
    const res: any = yield call(CheckAbhaExistsApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* checkAbhaExistsWatcher() {
  yield takeLatest(CHECK_ABHA_EXISTS, checkAbhaExistsWorker);
}

export function* verifyAbhaPhoneWorker(action: any): any {
  try {
    const res: any = yield call(VerifyAbhaPhoneApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* verifyAbhaPhoneWatcher() {
  yield takeLatest(VERIFY_ABHA_PHONE, verifyAbhaPhoneWorker);
}

export function* verifyAbhaOtpWorker(action: any): any {
  try {
    const res: any = yield call(VerifyAbhaOtpApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* verifyAbhaOtpWatcher() {
  yield takeLatest(VERIFY_ABHA_OTP, verifyAbhaOtpWorker);
}

export function* addAbhaWorker(action: any): any {
  try {
    const res: any = yield call(AddAbhaApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* addAbhaWatcher() {
  yield takeLatest(ADD_ABHA, addAbhaWorker);
}

export function* getAllAbhaCustomersWorker(action: any): any {
  try {
    const res: any = yield call(GetAllAbhaCustomersApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllAbhaCustomersWatcher() {
  yield takeLatest(GET_ALL_ABHA_CUSTOMERS, getAllAbhaCustomersWorker);
}

export function* linkAbhaDocumentWorker(action: any): any {
  try {
    const res: any = yield call(LinkAbhaDocumentApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* linkAbhaDocumentWatcher() {
  yield takeLatest(LINK_ABHA_DOCUMENT, linkAbhaDocumentWorker);
}

export function* getItemCategoriesWorker(action: any): any {
  try {
    const res: any = yield call(GetItemCategoriesApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getItemCategoriesWatcher() {
  yield takeLatest(GET_ITEM_CATEGORIES, getItemCategoriesWorker);
}

export function* editCategoryWorker(action: any): any {
  try {
    const res: any = yield call(EditCategoryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* editCategoryWatcher() {
  yield takeLatest(EDIT_CATEGORY, editCategoryWorker);
}

export function* createCategoryWorker(action: any): any {
  try {
    const res: any = yield call(CreateCategoryApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createCategoryWatcher() {
  yield takeLatest(CREATE_CATEGORY, createCategoryWorker);
}

export function* createCustomerWorker(action: any): any {
  try {
    const res: any = yield call(CreateCustomerApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      const errorMsg = res?.data?.message || res?.data?.error || "Failed to create customer";
      yield call(action.onError, { message: errorMsg, response: res });
    }
  } catch (error: any) {
    console.error("Create customer error:", error);
    
    // Handle 502 Bad Gateway specifically
    if (error?.response?.status === 502) {
      const errorMsg = error?.userMessage || 
                       "Backend server is not responding (502 Bad Gateway). Please check if the server is running and accessible.";
      yield call(action.onError, { 
        message: errorMsg, 
        response: error?.response,
        status: 502
      });
      return;
    }
    
    // Handle other errors
    const errorMsg = error?.response?.data?.message || 
                     error?.response?.data?.error || 
                     error?.userMessage ||
                     error?.message || 
                     "Network error. Please check your connection.";
    yield call(action.onError, { 
      message: errorMsg, 
      response: error?.response,
      status: error?.response?.status,
      isNetworkError: !error?.response 
    });
  }
}

export function* createCustomerWatcher() {
  yield takeLatest(CREATE_CUSTOMER, createCustomerWorker);
}

export function* getItemProductsWorker(action: any): any {
  try {
    const res: any = yield call(GetItemProductsApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getItemProductsWatcher() {
  yield takeLatest(GET_ITEM_PRODUCTS, getItemProductsWorker);
}

export function* getProductByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetProductByIdApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getProductByIdWatcher() {
  yield takeLatest(GET_PRODUCT_BY_ID, getProductByIdWorker);
}

export function* convertToLeadWorker(action: any): any {
  try {
    const res: any = yield call(ConvertToLeadApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      const errorMsg = res?.data?.message || res?.data?.error || "Failed to convert to lead";
      yield call(action.onError, { message: errorMsg, response: res });
    }
  } catch (error: any) {
    console.error("Convert to lead error:", error);
    
    // Handle 502 Bad Gateway specifically
    if (error?.response?.status === 502) {
      const errorMsg = error?.userMessage || 
                       "Backend server is not responding (502 Bad Gateway). Please check if the server is running and accessible.";
      yield call(action.onError, { 
        message: errorMsg, 
        response: error?.response,
        status: 502
      });
      return;
    }
    const errorMessage = error?.response?.data?.message || error?.message || 'Unable to convert to lead';
    yield call(action.onError, { message: errorMessage, response: error?.response ?? error });
  }
}

export function* convertToLeadWatcher() {
  yield takeLatest(CONVERT_TO_LEAD, convertToLeadWorker);
}

// Carousel Sagas
export function* getCarouselUrlsWorker(action: any): any {
  try {
    const res: any = yield call(GetCarouselUrlsApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCarouselUrlsWatcher() {
  yield takeLatest(GET_CAROUSEL_URLS, getCarouselUrlsWorker);
}

export function* uploadCarouselImageWorker(action: any): any {
  try {
    const res: any = yield call(UploadCarouselImageApi, action.data.file);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadCarouselImageWatcher() {
  yield takeLatest(UPLOAD_CAROUSEL_IMAGE, uploadCarouselImageWorker);
}

export function* deleteCarouselImageWorker(action: any): any {
  try {
    const res: any = yield call(DeleteCarouselImageApi, action.data.filename);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteCarouselImageWatcher() {
  yield takeLatest(DELETE_CAROUSEL_IMAGE, deleteCarouselImageWorker);
}

// Social Links Sagas
export function* getSocialLinksWorker(action: any): any {
  try {
    const res: any = yield call(GetSocialLinksApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getSocialLinksWatcher() {
  yield takeLatest(GET_SOCIAL_LINKS, getSocialLinksWorker);
}

export function* getAboutUsWorker(action: any): any {
  try {
    const res: any = yield call(GetAboutUsApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAboutUsWatcher() {
  yield takeLatest(GET_ABOUT_US, getAboutUsWorker);
}

export function* setAboutUsWorker(action: any): any {
  try {
    const res: any = yield call(SetAboutUsApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* setAboutUsWatcher() {
  yield takeLatest(SET_ABOUT_US, setAboutUsWorker);
}

export function* deleteCustomerAccountWorker(action: any): any {
  try {
    const res: any = yield call(DeleteCustomerAccountApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteCustomerAccountWatcher() {
  yield takeLatest(DELETE_CUSTOMER_ACCOUNT, deleteCustomerAccountWorker);
}

export function* deleteUserAccountWorker(action: any): any {
  try {
    const res: any = yield call(DeleteUserAccountApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteUserAccountWatcher() {
  yield takeLatest(DELETE_USER_ACCOUNT, deleteUserAccountWorker);
}

export function* uploadAboutUsImageWorker(action: any): any {
  try {
    // onSuccess gets the whole response: callers read response.data.data.url.
    const response: any = yield call(UploadAboutUsImageApi, action.file);
    if ((response?.status === 200 || response?.status === 201) && response?.data?.status !== false) {
      yield call(action.onSuccess, response);
    } else {
      yield call(action.onError, response?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadAboutUsImageWatcher() {
  yield takeLatest(UPLOAD_ABOUT_US_IMAGE, uploadAboutUsImageWorker);
}

export function* setSocialLinksWorker(action: any): any {
  try {
    const res: any = yield call(SetSocialLinksApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* setSocialLinksWatcher() {
  yield takeLatest(SET_SOCIAL_LINKS, setSocialLinksWorker);
}

// Diet Compliance Sagas
export function* getDietComplianceWorker(action: any): any {
  try {
    const res: any = yield call(GetDietComplianceApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getDietComplianceWatcher() {
  yield takeLatest(GET_DIET_COMPLIANCE, getDietComplianceWorker);
}

export function* getDietPlanConfigWorker(action: any): any {
  try {
    const res: any = yield call(GetDietPlanConfigApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getDietPlanConfigWatcher() {
  yield takeLatest(GET_DIET_PLAN_CONFIG, getDietPlanConfigWorker);
}

export function* setDietPlanStartDateWorker(action: any): any {
  try {
    const res: any = yield call(SetDietPlanStartDateApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* setDietPlanStartDateWatcher() {
  yield takeLatest(SET_DIET_PLAN_START_DATE, setDietPlanStartDateWorker);
}

export function* setDietComplianceWorker(action: any): any {
  try {
    const res: any = yield call(SetDietComplianceApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* setDietComplianceWatcher() {
  yield takeLatest(SET_DIET_COMPLIANCE, setDietComplianceWorker);
}

export function* getBookedSessionsByDateWorker(action: any): any {
  try {
    const res: any = yield call(GetBookedSessionsByDateApi, { date: action.date });
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getBookedSessionsByDateWatcher() {
  yield takeLatest(GET_BOOKED_SESSIONS_BY_DATE, getBookedSessionsByDateWorker);
}

export function* changeSessionStatusWorker(action: any): any {
  try {
    const res: any = yield call(ChangeSessionStatusApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* changeSessionStatusWatcher() {
  yield takeLatest(CHANGE_SESSION_STATUS, changeSessionStatusWorker);
}

export function* getMealOptionsWorker(action: any): any {
  try {
    const res: any = yield call(GetMealOptionsApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getMealOptionsWatcher() {
  yield takeLatest(GET_MEAL_OPTIONS, getMealOptionsWorker);
}

export function* getMealManagementOrdersWorker(action: any): any {
  try {
    const res: any = yield call(GetMealManagementOrdersApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getMealManagementOrdersWatcher() {
  yield takeLatest(GET_MEAL_MANAGEMENT_ORDERS, getMealManagementOrdersWorker);
}

export function* getGuidelinesWorker(action: any): any {
  try {
    const res: any = yield call(GetGuidelinesApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getGuidelinesWatcher() {
  yield takeLatest(GET_GUIDELINES, getGuidelinesWorker);
}

export function* setOrUpdateGuidelinesWorker(action: any): any {
  try {
    const res: any = yield call(SetOrUpdateGuidelinesApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* setOrUpdateGuidelinesWatcher() {
  yield takeLatest(SET_OR_UPDATE_GUIDELINES, setOrUpdateGuidelinesWorker);
}

export function* getBookedSessionsByCustomerWorker(action: any): any {
  try {
    const res: any = yield call(GetBookedSessionsByCustomerApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getBookedSessionsByCustomerWatcher() {
  yield takeLatest(GET_BOOKED_SESSIONS_BY_CUSTOMER, getBookedSessionsByCustomerWorker);
}

// Health Feed Sagas
export function* uploadImageWorker(action: any): any {
  try {
    const response: any = yield call(UploadImageApi, action.file);
    // Gated like the other 83 workers: this API reports failures as HTTP 200
    // with `status: false`, so axios does not throw and the catch below never
    // runs. Ungated, a rejected call reached onSuccess and the screen reported
    // success for work the server refused.
    //
    // onSuccess still receives the whole axios response, not response.data —
    // the upload callers read `response?.data?.data?.url` off it.
    if ((response?.status === 200 || response?.status === 201) && response?.data?.status !== false) {
      yield call(action.onSuccess, response);
    } else {
      yield call(action.onError, response?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* uploadImageWatcher() {
  yield takeLatest(UPLOAD_IMAGE, uploadImageWorker);
}

export function* createHealthFeedWorker(action: any): any {
  try {
    const res: any = yield call(CreateHealthFeedApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* createHealthFeedWatcher() {
  yield takeLatest(CREATE_HEALTH_FEED, createHealthFeedWorker);
}

export function* getCustomerPaymentsWorker(action: any): any {
  try {
    const res: any = yield call(GetCustomerPaymentsApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getCustomerPaymentsWatcher() {
  yield takeLatest(GET_CUSTOMER_PAYMENTS, getCustomerPaymentsWorker);
}

/**
 * All four document routes answer the same envelope and differ only in whether
 * they carry a body — GET /document/get takes none, per the collection.
 */
const documentWorker = (apiFn: any, withData: boolean) =>
  function* (action: any): any {
    try {
      const res: any = withData
        ? yield call(apiFn, action.data)
        : yield call(apiFn);
      if (res?.status === 200 && res?.data?.status !== false) {
        yield call(action.onSuccess, res.data);
      } else {
        yield call(action.onError, res?.data);
      }
    } catch (error: any) {
      yield call(action.onError, error?.response?.data ?? error);
    }
  };

export const getDocumentsWorker = documentWorker(GetDocumentsApi, true);
export const setDocumentWorker = documentWorker(SetDocumentApi, true);
export const updateDocumentWorker = documentWorker(UpdateDocumentApi, true);
export const deleteDocumentWorker = documentWorker(DeleteDocumentApi, true);

export function* getDocumentsWatcher() {
  yield takeLatest(GET_DOCUMENTS, getDocumentsWorker);
}
export function* setDocumentWatcher() {
  yield takeLatest(SET_DOCUMENT, setDocumentWorker);
}
export function* updateDocumentWatcher() {
  yield takeLatest(UPDATE_DOCUMENT, updateDocumentWorker);
}
export function* deleteDocumentWatcher() {
  yield takeLatest(DELETE_DOCUMENT, deleteDocumentWorker);
}

export function* getAllDietComplianceWorker(action: any): any {
  try {
    const res: any = yield call(GetAllDietComplianceApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllDietComplianceWatcher() {
  yield takeLatest(GET_ALL_DIET_COMPLIANCE, getAllDietComplianceWorker);
}

export function* getPromosWorker(action: any): any {
  try {
    const res: any = yield call(GetPromosApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getPromosWatcher() {
  yield takeLatest(GET_PROMOS, getPromosWorker);
}

export function* getAllHealthFeedWorker(action: any): any {
  try {
    const res: any = yield call(GetAllHealthFeedApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getAllHealthFeedWatcher() {
  yield takeLatest(GET_ALL_HEALTH_FEED, getAllHealthFeedWorker);
}

export function* getHealthFeedByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetHealthFeedByIdApi, action.id);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getHealthFeedByIdWatcher() {
  yield takeLatest(GET_HEALTH_FEED_BY_ID, getHealthFeedByIdWorker);
}

export function* deleteHealthFeedWorker(action: any): any {
  try {
    const res: any = yield call(DeleteHealthFeedApi, action.id);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* deleteHealthFeedWatcher() {
  yield takeLatest(DELETE_HEALTH_FEED, deleteHealthFeedWorker);
}

export function* updateHealthFeedWorker(action: any): any {
  try {
    const res: any = yield call(UpdateHealthFeedApi, action.id, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateHealthFeedWatcher() {
  yield takeLatest(UPDATE_HEALTH_FEED, updateHealthFeedWorker);
}

export function* getListOfEnrollmentsWorker(action: any): any {
  try {
    const res: any = yield call(GetListOfEnrollmentsApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getListOfEnrollmentsWatcher() {
  yield takeLatest(GET_LIST_OF_ENROLLMENTS, getListOfEnrollmentsWorker);
}

export function* getEnrollmentResponseWorker(action: any): any {
  try {
    const res: any = yield call(GetEnrollmentResponseApi, action.data);
    if ((res?.status === 200 || res?.status === 201) && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* getEnrollmentResponseWatcher() {
  yield takeLatest(GET_ENROLLMENT_RESPONSE, getEnrollmentResponseWorker);
}